/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../../_chunks/dep-e43cf21c.js';
import { useState, useMemo, useRef, useEffect } from 'react';
import { g as get_1 } from '../../_chunks/dep-337b4140.js';
import { HOOK_MARK } from './useForm.js';
import '../../_chunks/dep-2acfafca.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-ca64038e.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-33ffecad.js';
import '../../_chunks/dep-fd3498b6.js';
import '../../_chunks/dep-e51b1270.js';
import '../../_chunks/dep-46de7b2e.js';
import '../../_common/js/log/index.js';
import '../../_common/js/log/log.js';

function useWatch(name, form) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var valueStr = useMemo(function () {
    return JSON.stringify(value);
  }, [value]);
  var valueStrRef = useRef(valueStr);
  var isValidForm = form && form._init;
  useEffect(function () {
    if (!isValidForm) return;
    var getFieldsValue = form.getFieldsValue,
      getInternalHooks = form.getInternalHooks;
    var _getInternalHooks = getInternalHooks(HOOK_MARK),
      registerWatch = _getInternalHooks.registerWatch;
    var cancelRegister = registerWatch(function () {
      var allFieldsValue2 = getFieldsValue(true);
      var newValue = get_1(allFieldsValue2, name);
      var nextValueStr = JSON.stringify(newValue);
      if (valueStrRef.current !== nextValueStr) {
        valueStrRef.current = nextValueStr;
        setValue(newValue);
      }
    });
    var allFieldsValue = getFieldsValue(true);
    var initialValue = get_1(allFieldsValue, name);
    setValue(initialValue);
    return cancelRegister;
  }, []);
  return value;
}

export { useWatch as default };
//# sourceMappingURL=useWatch.js.map
